import { ReactComponent as ListSVG } from "./svg/icon_List.svg";
import "./IconList.scss";

export const IconList = () => {
  return (
    <span className="icon-list">
      <ListSVG />
    </span>
  );
};
